import React, { Component } from 'react';
import './SiteTitle.css';
import { Col, Row } from 'reactstrap';

export class SiteTitle extends Component {
  static displayName = SiteTitle.name;

  render() {
    return (
      <Row id="site-title">
        <Col md='12'>
          <h2 style={{ textAlign: 'center' }}>教育體系網站弱點掃描服務平台</h2>
        </Col>
        <Col md='12'>
          <h5 style={{ textAlign: 'center' }}>Educational Institutions Vulnerability Scanning Service Platform</h5>
        </Col>
      </Row>
    );
  }
}